var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHumanRights = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Election-4--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Election 4 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.62 24v-1.51a8.4 8.4 0 0 0 4.88 -7.74 1.5 1.5 0 0 0 -3 0 5.5 5.5 0 0 1 -11 0 1.5 1.5 0 0 0 -3 0 8.63 8.63 0 0 0 5.12 7.74V24Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.74 0a1 1 0 0 0 -1 0.35A55.09 55.09 0 0 1 2.29 0.38a1 1 0 0 0 -1.76 0.86l2.71 11.08A3 3 0 0 1 5 11.75h0.16L4.49 9a42.89 42.89 0 0 0 7.51 0.75A42.89 42.89 0 0 0 19.51 9l-0.67 2.76H19a3 3 0 0 1 1.76 0.57l2.71 -11.09A1 1 0 0 0 22.74 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHumanRights);
export default ForwardRef;